// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pre-upload-file-list-table-container {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  /* File name cell with word wrap styling */
  /* Delete button styling */
}
.pre-upload-file-list-table-container h4 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
  flex-shrink: 0;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* Remove all borders from DataTable */
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable {
  border: none !important;
  width: 100% !important;
  max-width: 100% !important;
  table-layout: fixed !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
  /* Scrollable wrapper */
  /* Header styling - no borders */
  /* Body row styling - no borders */
  /* Remove all divider styles */
  /* Scrollbar styling */
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-wrapper {
  flex: 1 1 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  max-width: 100% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th {
  background-color: #f8f9fa !important;
  color: #333 !important;
  font-weight: 600 !important;
  padding: 1rem !important;
  border: none !important;
  border-width: 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  word-break: break-word;
  /* Enforce column widths using nth-child */
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th:nth-child(1) {
  width: 25% !important;
  max-width: 25% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th:nth-child(2) {
  width: 15% !important;
  max-width: 15% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th:nth-child(3) {
  width: 25% !important;
  max-width: 25% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th:nth-child(4) {
  width: 10% !important;
  max-width: 10% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th:nth-child(5) {
  width: 5% !important;
  max-width: 5% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr {
  border: none !important;
  border-width: 0 !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td {
  padding: 1rem !important;
  color: #595959 !important;
  border: none !important;
  border-width: 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  word-break: break-word;
  /* Enforce column widths using nth-child */
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td.text-center {
  text-align: center;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td:nth-child(1) {
  width: 25% !important;
  max-width: 25% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td:nth-child(2) {
  width: 15% !important;
  max-width: 15% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td:nth-child(3) {
  width: 25% !important;
  max-width: 25% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td:nth-child(4) {
  width: 10% !important;
  max-width: 10% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td:nth-child(5) {
  width: 5% !important;
  max-width: 5% !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr:hover {
  background-color: #f8f9fa !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-thead > tr > th:last-child {
  border-right: none !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-tbody > tr > td:last-child {
  border-right: none !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-wrapper::-webkit-scrollbar {
  width: 8px;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.pre-upload-file-list-table-container .pre-upload-file-list-table .p-datatable .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.pre-upload-file-list-table-container .pre-upload-file-list-header {
  background-color: #f8f9fa !important;
  color: #333 !important;
  font-weight: 600 !important;
  border: none !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-data-row {
  padding: 1rem !important;
  color: #595959 !important;
  border: none !important;
}
.pre-upload-file-list-table-container .pre-upload-file-list-data-row.text-center {
  text-align: center;
}
.pre-upload-file-list-table-container .file-name-cell {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: block;
}
.pre-upload-file-list-table-container .p-button-danger.p-button-rounded.p-button-text {
  width: 36px;
  height: 36px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #dc3545;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.pre-upload-file-list-table-container .p-button-danger.p-button-rounded.p-button-text:hover {
  background-color: rgba(220, 53, 69, 0.1);
  color: #c82333;
}
.pre-upload-file-list-table-container .p-button-danger.p-button-rounded.p-button-text .p-icon {
  font-size: 1.125rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Projects/FilesAndFolder/PreUploadFileListTable.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EAoLA,0CAAA;EAQA,0BAAA;AAzLF;AADE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAGJ;AAAE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EAEA,sCAAA;AACJ;AAAI;EACE,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;EACA,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EAEA,uBAAA;EAQA,gCAAA;EA4CA,kCAAA;EAqDA,8BAAA;EASA,sBAAA;AA7GN;AAJM;EACE,oBAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;AAMR;AAAU;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;EACA,sBAAA;EAEA,0CAAA;AACZ;AAAY;EACE,qBAAA;EACA,yBAAA;AAEd;AACY;EACE,qBAAA;EACA,yBAAA;AACd;AAEY;EACE,qBAAA;EACA,yBAAA;AAAd;AAGY;EACE,qBAAA;EACA,yBAAA;AADd;AAIY;EACE,oBAAA;EACA,wBAAA;AAFd;AAUQ;EACE,uBAAA;EACA,0BAAA;AARV;AAUU;EACE,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;EACA,sBAAA;EAMA,0CAAA;AAbZ;AASY;EACE,kBAAA;AAPd;AAWY;EACE,qBAAA;EACA,yBAAA;AATd;AAYY;EACE,qBAAA;EACA,yBAAA;AAVd;AAaY;EACE,qBAAA;EACA,yBAAA;AAXd;AAcY;EACE,qBAAA;EACA,yBAAA;AAZd;AAeY;EACE,oBAAA;EACA,wBAAA;AAbd;AAiBU;EACE,oCAAA;AAfZ;AAqBM;EACE,6BAAA;AAnBR;AAsBM;EACE,6BAAA;AApBR;AAwBM;EACE,UAAA;AAtBR;AAyBM;EACE,mBAAA;EACA,mBAAA;AAvBR;AA0BM;EACE,gBAAA;EACA,mBAAA;AAxBR;AA0BQ;EACE,gBAAA;AAxBV;AA8BE;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AA5BJ;AA+BE;EACE,wBAAA;EACA,yBAAA;EACA,uBAAA;AA7BJ;AA+BI;EACE,kBAAA;AA7BN;AAkCE;EACE,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAhCJ;AAoCE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AAlCJ;AAoCI;EACE,wCAAA;EACA,cAAA;AAlCN;AAqCI;EACE,mBAAA;AAnCN","sourcesContent":[".pre-upload-file-list-table-container {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n\n  h4 {\n    margin: 0 0 1rem 0;\n    color: #333;\n    font-size: 1rem;\n    font-weight: 600;\n    flex-shrink: 0;\n  }\n\n  .pre-upload-file-list-table {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n\n    /* Remove all borders from DataTable */\n    .p-datatable {\n      border: none !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      table-layout: fixed !important;\n      display: flex !important;\n      flex-direction: column !important;\n      height: 100% !important;\n      overflow: hidden !important;\n\n      /* Scrollable wrapper */\n      .p-datatable-wrapper {\n        flex: 1 !important;\n        overflow-x: hidden !important;\n        overflow-y: auto !important;\n        max-width: 100% !important;\n      }\n\n      /* Header styling - no borders */\n      .p-datatable-thead {\n        > tr {\n          > th {\n            background-color: #f8f9fa !important;\n            color: #333 !important;\n            font-weight: 600 !important;\n            padding: 1rem !important;\n            border: none !important;\n            border-width: 0 !important;\n            overflow: hidden !important;\n            text-overflow: ellipsis !important;\n            white-space: nowrap !important;\n            word-break: break-word;\n\n            /* Enforce column widths using nth-child */\n            &:nth-child(1) {\n              width: 25% !important;\n              max-width: 25% !important;\n            }\n\n            &:nth-child(2) {\n              width: 15% !important;\n              max-width: 15% !important;\n            }\n\n            &:nth-child(3) {\n              width: 25% !important;\n              max-width: 25% !important;\n            }\n\n            &:nth-child(4) {\n              width: 10% !important;\n              max-width: 10% !important;\n            }\n\n            &:nth-child(5) {\n              width: 5% !important;\n              max-width: 5% !important;\n            }\n          }\n        }\n      }\n\n      /* Body row styling - no borders */\n      .p-datatable-tbody {\n        > tr {\n          border: none !important;\n          border-width: 0 !important;\n\n          > td {\n            padding: 1rem !important;\n            color: #595959 !important;\n            border: none !important;\n            border-width: 0 !important;\n            overflow: hidden !important;\n            text-overflow: ellipsis !important;\n            white-space: nowrap !important;\n            word-break: break-word;\n\n            &.text-center {\n              text-align: center;\n            }\n\n            /* Enforce column widths using nth-child */\n            &:nth-child(1) {\n              width: 25% !important;\n              max-width: 25% !important;\n            }\n\n            &:nth-child(2) {\n              width: 15% !important;\n              max-width: 15% !important;\n            }\n\n            &:nth-child(3) {\n              width: 25% !important;\n              max-width: 25% !important;\n            }\n\n            &:nth-child(4) {\n              width: 10% !important;\n              max-width: 10% !important;\n            }\n\n            &:nth-child(5) {\n              width: 5% !important;\n              max-width: 5% !important;\n            }\n          }\n\n          &:hover {\n            background-color: #f8f9fa !important;\n          }\n        }\n      }\n\n      /* Remove all divider styles */\n      .p-datatable-thead > tr > th:last-child {\n        border-right: none !important;\n      }\n\n      .p-datatable-tbody > tr > td:last-child {\n        border-right: none !important;\n      }\n\n      /* Scrollbar styling */\n      .p-datatable-wrapper::-webkit-scrollbar {\n        width: 8px;\n      }\n\n      .p-datatable-wrapper::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 10px;\n      }\n\n      .p-datatable-wrapper::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 10px;\n\n        &:hover {\n          background: #555;\n        }\n      }\n    }\n  }\n\n  .pre-upload-file-list-header {\n    background-color: #f8f9fa !important;\n    color: #333 !important;\n    font-weight: 600 !important;\n    border: none !important;\n  }\n\n  .pre-upload-file-list-data-row {\n    padding: 1rem !important;\n    color: #595959 !important;\n    border: none !important;\n\n    &.text-center {\n      text-align: center;\n    }\n  }\n\n  /* File name cell with word wrap styling */\n  .file-name-cell {\n    white-space: normal;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    display: block;\n  }\n\n  /* Delete button styling */\n  .p-button-danger.p-button-rounded.p-button-text {\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #dc3545;\n    transition: all 0.3s ease;\n    flex-shrink: 0;\n\n    &:hover {\n      background-color: rgba(220, 53, 69, 0.1);\n      color: #c82333;\n    }\n\n    .p-icon {\n      font-size: 1.125rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
